import { render, staticRenderFns } from "./EditDiscountModal.vue?vue&type=template&id=9405bdfc"
import script from "./EditDiscountModal.vue?vue&type=script&lang=js"
export * from "./EditDiscountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports